import {
  Condition,
  ReturnRateOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface ReturnRateState {
  returnRate: string;
  comparison: ReturnRateOption | null;
}

export const RETURN_RATE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnRateState>>,
): ConditionType<ReturnRateState, Condition.ReturnRate> => ({
  name: "Customer return rate",
  description(state) {
    if (!state.comparison) {
      return "The percentage of orders this customer has returned";
    }
    return `Customer return rate ${state.comparison.toLowerCase()} ${state.returnRate}`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnRateState>) {
    return React.createElement(Details, props);
  },
  empty: { returnRate: "0", comparison: null },
  fromModel(model) {
    const decimalStr = model.returnRate.toString();
    // Convert to percentage
    const formatted = (+decimalStr * 100).toFixed(0);
    return { returnRate: formatted, comparison: model.comparison };
  },
  toModel(state) {
    return {
      type: Condition.RETURN_RATE,
      // Store as decimal
      returnRate: +state.returnRate / 100,
      comparison: state.comparison,
    };
  },
  valid(state) {
    return state.comparison !== null;
  },
});
